import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AuthService } from 'app/core';
import { TreoAnimations } from 'tsui/@treo';
import { EMAIL_PATTERN } from 'app/shared/Utils/common.utils';

@Component({
  selector: 'auth-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: TreoAnimations,
})
export class AuthForgotPasswordComponent implements OnInit {
  forgotPasswordForm: UntypedFormGroup;
  message: any;

  /**
   * Constructor
   *
   * @param {FormBuilder} _formBuilder
   */
  constructor(private _formBuilder: UntypedFormBuilder, private _authService: AuthService) {
    // Set the defaults
    this.message = null;
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    // Create the form
    this.forgotPasswordForm = this._formBuilder.group({
      email: ['', [Validators.required, Validators.email, Validators.pattern(EMAIL_PATTERN)]],
    });
  }

  /**
   * Go to home page
   */
  goHome(): void {
    window.open('https://www.termsheet.com');
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Send the reset link
   */
  sendResetLink(): void {
    // Do nothing if the form is invalid
    if (this.forgotPasswordForm.invalid) {
      return;
    }

    // Disable the form
    this.forgotPasswordForm.disable();

    // Hide the message
    this.message = null;

    const credentials = this.forgotPasswordForm.value;

    // Do your action here...
    this._authService.forgotPassword(credentials).subscribe(
      () => {
        // Re-enable the form
        this.forgotPasswordForm.enable();

        // Reset the form
        this.forgotPasswordForm.reset({});

        // Show the message
        this.message = {
          appearance: 'outline',
          content: "Password reset sent! You'll receive an email if you are registered on our system.",
          shake: false,
          showIcon: false,
          type: 'success',
        };
      },
      (response) => {
        // Re-enable the form
        this.forgotPasswordForm.enable();

        // Show the error message
        this.message = {
          appearance: 'outline',
          content: response.error.user_authentication,
          shake: true,
          showIcon: false,
          type: 'error',
        };
      },
    );
  }
}
